import { NotificationTemplateTypes } from '../base-types';

const replaceMap: Record<string, string> = {
  Issues: 'Tasks',
  'Issues All Issues': 'Tasks All Tasks',
};

// eslint-disable-next-line import-x/prefer-default-export
export const getPrepareNotificationsSettings = (
  data: {
    key: NotificationTemplateTypes;
    pages?: {
      key: NotificationTemplateTypes;
      actions?: {
        key: NotificationTemplateTypes;
      }[];
    }[];
  }[],
) => {
  const map: Partial<Record<string, {
      title: string;
      pagesKeys: NotificationTemplateTypes[] | [];
      pages?: Partial<Record<string, {
          title: string;
          sectionKey: NotificationTemplateTypes;
          actionsKeys: NotificationTemplateTypes[] | [];
          actions?: Partial<Record<string, {
              title: string;
              description: string;
              sectionKey: NotificationTemplateTypes;
              pageKey: NotificationTemplateTypes;
            }>>;
        }>>;
    }>> = {};

  data.map((section) => {
    let sectionsKeyArray = NotificationTemplateTypes[section.key]?.split('_');

    if (!NotificationTemplateTypes[section.key]) {
      sectionsKeyArray = section.key.split('_');
    }

    let sectionTitle = sectionsKeyArray
      ?.splice(1)
      ?.map((item) => `${item.charAt(0)}${item.slice(1).toLowerCase()}`)
      ?.join(' ');

    if (replaceMap[sectionTitle]) {
      sectionTitle = replaceMap[sectionTitle];
    }

    map[section.key] = {
      title: sectionTitle,
      pagesKeys: [],
    };

    if (section.pages?.length) {
      section.pages.map((page) => {
        if (map[section.key]?.pages === undefined) {
          map[section.key]!.pages = {};
        }
        let pagesKeyArray = NotificationTemplateTypes[page.key]?.split('_');

        if (!NotificationTemplateTypes[page.key]) {
          pagesKeyArray = page?.key?.split('_');
        }

        let pageTitle = pagesKeyArray
          ?.map((item) => {
            const result = `${item.charAt(0)}${item.slice(1).toLowerCase()}`;

            return result;
          })
          ?.join(' ');

        if (replaceMap[pageTitle]) {
          pageTitle = replaceMap[pageTitle];
        }

        map[section.key]!.pages![page.key] = {
          title: pageTitle,
          sectionKey: section.key,
          actionsKeys: [],
        };

        map[section.key]!.pagesKeys = [
          ...map[section.key]!.pagesKeys,
          page.key,
        ];

        if (page.actions?.length) {
          page.actions.map((action) => {
            if (map[section.key]!.pages![page.key]!.actions === undefined) {
              map[section.key]!.pages![page.key]!.actions = {};
            }

            let actionsKeyArray =
              NotificationTemplateTypes[action.key]?.split('_');

            if (!NotificationTemplateTypes[action.key]) {
              actionsKeyArray = action.key.split('_');
            }

            const actionTitle = actionsKeyArray
              ?.map((item) => {
                const result = `${item.charAt(0)}${item
                  .slice(1)
                  .toLowerCase()}`;

                return result;
              })
              ?.join(' ');

            let actionTitleResult = actionTitle;

            Object.keys(replaceMap).forEach((key) => {
              if (actionTitle.includes(key)) {
                actionTitleResult = actionTitle.replace(key, replaceMap[key]);
              }
            });

            actionTitleResult = actionTitleResult.replace('Action', '');

            map[section.key]!.pages![page.key]!.actions![action.key] = {
              title: actionTitleResult,
              description: map[section.key]!.pages![page.key]?.title || '',
              sectionKey: section.key,
              pageKey: page.key,
            };

            map[section.key]!.pages![page.key]!.actionsKeys = [
              ...map[section.key]!.pages![page.key]!.actionsKeys,
              action.key,
            ];

            return null;
          });
        }
        return null;
      });
    }
    return null;
  });

  return map;
};
